import React from "react";

function SvgIcMapPoi002(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M18 16h-4v-4h4c1.611 0 1.977 1.101 2 2 0 .602-.194 2-2 2m0-8h-8v16h4v-4h4c4.402 0 6-3.588 6-6s-1.598-6-6-6"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi002;
